import { Dumbbell } from 'lucide-react'
import { APP_ROUTES } from '../config/app'

export function Footer() {
  return (
    <footer className="relative border-t border-white/[0.06] bg-charcoal-black px-6 pb-12 pt-14 md:pt-16">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 items-start">
          <div>
            <div className="flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-electric-cyan to-deep-purple shadow-[0_0_20px_rgba(0,217,255,0.25)]">
                <Dumbbell className="h-[18px] w-[18px] text-charcoal-black" aria-hidden />
              </span>
              <span className="font-semibold text-soft-white text-lg">Boomshift</span>
            </div>
            <p className="text-sm text-muted-silver mt-3 max-w-[28ch]">Built for the long game.</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.18em] font-semibold text-muted-silver mb-3">
              Access
            </p>
            <p className="text-sm text-muted-silver leading-relaxed">
              Private beta only. Public access is not open yet.
            </p>
            <p className="text-sm text-muted-silver/70 mt-3">Trainer signup — coming soon.</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.18em] font-semibold text-muted-silver mb-3">
              Notes
            </p>
            <p className="text-sm text-muted-silver leading-relaxed">
              Currently in private beta. No public signup yet.
            </p>
            <p className="text-sm text-muted-silver leading-relaxed mt-2">
              Have a trainer who uses Boomshift? Sign in with the email they invited you with.
            </p>
          </div>
        </div>
        <div className="mt-12 border-t border-white/[0.05] pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-silver">
            <span>© 2026 Boomshift. Built for the long game.</span>
            <div className="flex items-center gap-4">
              <span>Made with care for everyday people.</span>
              <a
                href={APP_ROUTES.login}
                className="text-muted-silver/55 transition hover:text-electric-cyan focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric-cyan/60 focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal-black"
              >
                Invited clients sign in
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
